import validUrl from 'valid-url';

var getId = function getId(resource) {
  return resource['@id'];
};

var getType = function getType(resource) {
  return resource['@type'];
};

var getNavDate = function getNavDate(resource) {
  return resource.navDate || null;
};

var VIEWING_DIRECTIONS = {
  LEFT_TO_RIGHT: 'left-to-right',
  RIGHT_TO_LEFT: 'right-to-left',
  TOP_TO_BOTTOM: 'top-to-bottom',
  BOTTOM_TO_TOP: 'bottom-to-top'
};

var getViewingDirection = function getViewingDirection(resource) {
  var viewingDirection = resource.viewingDirection;
  if (typeof viewingDirection !== 'string') {
    return VIEWING_DIRECTIONS.LEFT_TO_RIGHT;
  }
  switch (viewingDirection.toLowerCase().trim()) {
    case VIEWING_DIRECTIONS.LEFT_TO_RIGHT:
    case VIEWING_DIRECTIONS.RIGHT_TO_LEFT:
    case VIEWING_DIRECTIONS.TOP_TO_BOTTOM:
    case VIEWING_DIRECTIONS.BOTTOM_TO_TOP:
      return viewingDirection.toLowerCase().trim();
    default:
      return VIEWING_DIRECTIONS.LEFT_TO_RIGHT;
  }
};

var getFormat = function getFormat(resource) {
  return resource.format || null;
};

var getHeight = function getHeight(resource) {
  return resource.height ? parseInt(resource.height, 10) : 0;
};

var getWidth = function getWidth(resource) {
  return resource.width ? parseInt(resource.width, 10) : 0;
};

var VIEWING_HINTS = {
  INDIVIDUALS: 'individuals',
  PAGED: 'paged',
  CONTINUOUS: 'continuous',
  MULTI_PART: 'multi-part',
  NON_PAGES: 'non-paged',
  TOP: 'top',
  FACING_PAGES: 'facing-pages'
};
var getViewingHint = function getViewingHint(resource) {
  var viewingHint = resource.viewingHint;
  if (typeof viewingHint !== 'string') {
    return null;
  }
  switch (viewingHint.toLowerCase().trim()) {
    case VIEWING_HINTS.INDIVIDUALS:
    case VIEWING_HINTS.PAGED:
    case VIEWING_HINTS.CONTINUOUS:
    case VIEWING_HINTS.MULTI_PART:
    case VIEWING_HINTS.NON_PAGES:
    case VIEWING_HINTS.TOP:
    case VIEWING_HINTS.FACING_PAGES:
      return viewingHint.toLowerCase().trim();
    default:
      // Should we handle custom viewing hints differently?
      return validUrl.isWebUri(viewingHint) ? viewingHint : null;
  }
};

var getWhitelistedViewingHint = function getWhitelistedViewingHint(whitelist) {
  return function (resource) {
    var viewingHint = getViewingHint(resource);
    if (!viewingHint) {
      return null;
    }
    if (whitelist.indexOf(viewingHint) >= 0) {
      return viewingHint;
    }
    return validUrl.isWebUri(viewingHint) ? viewingHint : null;
  };
};

// @todo whitelist motivations + URIs.
var getMotivation = function getMotivation(resource) {
  return resource.motivation;
};

export { getId, getType, getViewingHint, getWhitelistedViewingHint, getNavDate, getViewingDirection, getFormat, getHeight, getWidth, getMotivation, VIEWING_DIRECTIONS, VIEWING_HINTS };